export default process.env.VUE_APP_PROD
  ? []
  : [
      {
        path: "/playground",
        name: "Playground",
        component: () => import(/* webpackChunkName: "dev" */ "@/views/Playground/Playground.vue")
      }
    ];
